import { QueryClient, QueryClientProvider } from 'react-query';
import { SnackbarProvider } from 'notistack';
import { CmsContentProvider } from 'src/contexts';
import { VideoFullscreenProvider } from 'src/contexts/VideoFullscreenContext';
import { WelcomeViewContextProvider } from 'src/contexts/WelcomeViewContext';
import { ThemeProvider } from 'src/styles';

import Layout from './Layout';

const queryClient = new QueryClient();

export const AppWrapper: React.FC<{
  navbar?: boolean;
  emptyNavbar?: boolean;
}> = ({
  children,
  navbar,
  emptyNavbar,
}) => (
  <QueryClientProvider client={queryClient}>
    <CmsContentProvider>
      <WelcomeViewContextProvider>
        <VideoFullscreenProvider>
          <ThemeProvider>
            <SnackbarProvider
              maxSnack={4}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
              <Layout navbar={navbar} emptyNavbar={emptyNavbar}>
                {children}
              </Layout>
            </SnackbarProvider>
          </ThemeProvider>
        </VideoFullscreenProvider>
      </WelcomeViewContextProvider>
    </CmsContentProvider>
  </QueryClientProvider>
);
